module.exports = __webpack_public_path__ + "media/images/lb/424-436519afd46e4a06855b5e1c79fee7e8.svg";